import { usePrefs } from 'wsm-common-data';

export function useIsVertical() {
	const { cardLayout } = usePrefs();
	const isVertical = cardLayout === 'vertical';

	return { isVertical };
}
